import { Dispatch } from 'redux';
import { AppDispatch } from '../store'; // Adjust the import path
import { ActionType } from '../../util/model'; // Import ActionType
import { TokenService } from '../../services/token.service';
import { RestApi } from '../../services/restapi.service';

export const activityStatusAction = (path: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch({ type: ActionType.ACTIVITY_STATUS_REQUEST }); // Dispatch a request action for loading state
    
    // Call the API function
    const response = await RestApi.activities(path, TokenService.mainInfo().email);
    const data = response.data; 
  if(data.pageName !== "EventReportDownload"){
      localStorage.setItem("activity_id", data.activity_id);
  }
    dispatch({
      type: ActionType.ACTIVITY_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    console.error('Error fetching activity status:', error);
    const errorMessage = error.response?.data?.error || error.message || 'An error occurred.';
    
    // Dispatch failure action with the error message
    dispatch({
      type: ActionType.ACTIVITY_STATUS_FAILURE,
      payload: errorMessage,
    });
  }
};

export const activityStatusForUpdate = (path: string, id: string | null) => async (dispatch: Dispatch) => {
  try {
    const response = await RestApi.activitiesUpdate(path, id);
    const data = response.data; 
    dispatch({
      type: ActionType.ACTIVITY_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    console.error('Error fetching activity status:', error);
    const errorMessage = error.response?.data?.error || error.message || 'An error occurred.';
    dispatch({
      type: ActionType.ACTIVITY_STATUS_FAILURE,
      payload: errorMessage,
    });
  }
}

// Action to fetch all activities
export const allActivityAction = (
  page: number,
  pageSize: number,
  activityType?: string,
  userId?: string,
  startDate?: Date,
  endDate?: Date // Add endDate as an optional parameter
) => async (dispatch: AppDispatch) => {
  try {
    dispatch({ type: ActionType.ACTIVITY_STATUS_REQUEST_ALL }); // Dispatch a request action for loading state

    // Handle the default behavior for startDate and endDate
    if (!startDate) {
      const last30DaysDate = new Date();
      last30DaysDate.setDate(last30DaysDate.getDate() - 30); // Set the start date to 30 days ago
      startDate = last30DaysDate; // Use the default start date
    }

    if (!endDate) {
      endDate = new Date(); // Default to the current date if endDate is not provided
    }

    // Call the API function with activityType, userId, startDate, and endDate
    const response = await RestApi.allActivities(page, pageSize, activityType, userId, startDate, endDate);  // Pass the filters to the API
    const data = response.data;

    // Assuming the API returns both 'activities' and 'combinedCount'
    dispatch({
      type: ActionType.ACTIVITY_STATUS_SUCCESS_ALL,
      payload: {
        activities: data.activities,       // List of activities
        totalActivities: data.combinedCount, // Total number of activities
        userdata: data.userdata,           // Store user data
        allUserLastActivity: data.UserLastActivity,
        hoursOnEachPageByUser: data.hoursOnEachPageByUser
      },
    });
  } catch (error: any) {
    console.error('Error fetching all activities:', error);
    const errorMessage = error.response?.data?.error || error.message || 'An error occurred.';
    dispatch({
      type: ActionType.ACTIVITY_STATUS_FAILURE_ALL,
      payload: errorMessage,
    });
  }
};

export const fetchUserSpentTime = (userId: string, ipAddress?: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch({ type: ActionType.ACTIVITY_SPENT_TIME_REQUEST });

    // Call the API
    const response = await RestApi.activitiesSpentTimeEachUser(userId, ipAddress);
    const data = response.data;

    dispatch({
      type: ActionType.ACTIVITY_SPENT_TIME_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    console.error('Error fetching spent time:', error);
    const errorMessage = error.response?.data?.error || error.message || 'An error occurred.';
    
    dispatch({
      type: ActionType.ACTIVITY_SPENT_TIME_FAILURE,
      payload: errorMessage,
    });
  }
};
